const CM_PER_INCH = 2.54;
export const MIN_HEIGHT_CM = 120;
export const MAX_HEIGHT_CM = 220;
export function cmToFeetInches(cm) {
    const totalInches = Math.round(cm / CM_PER_INCH);
    return { feet: Math.floor(totalInches / 12), inches: totalInches % 12 };
}
export function feetInchesToCm(feet, inches) {
    return Math.round((feet * 12 + inches) * CM_PER_INCH);
}
export function formatHeight(cm) {
    if (cm === null || cm === undefined || Number.isNaN(cm))
        return '';
    const { feet, inches } = cmToFeetInches(cm);
    return `${feet}'${inches}"`;
}
//# sourceMappingURL=height.js.map